import * as React from "react";
import TextField from "@mui/material/TextField";
import { Controller } from "react-hook-form";
import { useMediaQuery, useTheme } from "@mui/material";

export default function TextFieldInput(props) {
  const {
    label,
    placeholder,
    name,
    control,
    type = "text",
    width,
    multiline,
    rows,
    required,
    rules,
    fullWidth = true,
    sx = {},
  } = props;

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <TextField
          label={label}
          placeholder={placeholder}
          variant="outlined"
          value={value || ""}
          onChange={onChange}
          type={type}
          error={!!error}
          helperText={error?.message}
          multiline={multiline}
          rows={rows}
          required={required}
          fullWidth={fullWidth}
          size={isMobile ? "medium" : "small"}
          sx={{
            width: width || (fullWidth ? "100%" : "auto"),
            "& .MuiOutlinedInput-root": {
              borderRadius: theme.shape.borderRadius,
              fontSize: { xs: "0.875rem", sm: "1rem" },
              "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: theme.palette.grey[400],
              },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: theme.palette.primary.dark,
                borderWidth: 2,
              },
            },
            "& .MuiInputLabel-root": {
              fontSize: { xs: "0.875rem", sm: "1rem" },
            },
            "& .MuiFormHelperText-root": {
              fontSize: { xs: "0.75rem", sm: "0.875rem" },
            },
            ...sx,
          }}
        />
      )}
    />
  );
}
